export default "__VITE_ASSET__QyMvz7fY__"